<template>
  <section class="table-sampler-classification-noise table-responsive">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th class="bg-grey text-left" style="width:25%;">Campo</th>
          <th class="text-center" style="width:37.5%;">NHO 01</th>
          <th class="text-center" style="width:37.5%;">NR 15</th>
        </tr>
      </thead>
      <tbody>
        <!-- Consideração técnica -->
        <tr>
          <td class="bg-grey">Consideração técnica</td>
            <td>
              <input type="text" class="form-control" v-model="model.nho.consideration" placeholder="Consideração Técnica NHO 01" disabled required />
            </td>
            <td>
              <input type="text" class="form-control" v-model="model.nr15.consideration" placeholder="Consideração Técnica NR 15" disabled required />
            </td>
        </tr>
        <!-- Dose diária -->
        <tr>
          <td class="bg-grey">Dose diária (%)</td>
          <td>
            <input type="text" class="form-control" v-model="model.nho.dose_daily" placeholder="Dose diária (%) NHO 01" disabled />
          </td>
          <td>
            <input type="text" class="form-control" v-model="model.nr15.dose_daily" placeholder="Dose diária (%) NR 15" disabled />
          </td>
        </tr>
        <!-- Dose diária Atenuante -->
        <tr>
          <td class="bg-grey">Dose diária (%) Atenuante</td>
          <td>
            <input type="text" class="form-control" v-model="model.nho.attenuating_daily_dose" placeholder="Dose diária (%) Atenuante NHO 01" disabled />
          </td>
          <td>
            <input type="text" class="form-control" v-model="model.nr15.attenuating_daily_dose" placeholder="Dose diária (%) Atenuante NR 15" disabled />
          </td>
        </tr>
        <!-- LEO -->
        <tr>
          <td class="bg-grey">LEO (%)</td>
          <td>
            <input type="text" class="form-control" v-model="model.nho.leo" placeholder="LEO (%) NHO 01" />
          </td>
          <td>
            <input type="text" class="form-control" v-model="model.nr15.leo" placeholder="LEO (%) NR 15" />
          </td>
        </tr>
        <!-- Atuação recomendada -->
        <tr>
          <td class="bg-grey">Atuação recomendada</td>
          <td>
            <textarea rows="2" style="resize:vertical" type="text" class="form-control" v-model="model.nho.recommended_action" placeholder="Atuação recomendada NHO 01" disabled />
          </td>
          <td>
            <textarea rows="2" style="resize:vertical" type="text" class="form-control" v-model="model.nr15.recommended_action" placeholder="Atuação recomendada NR 15" disabled/>
          </td>
        </tr>
        <!-- Recomendação da exposição -->
        <tr>
          <td class="bg-grey">Recomendação da exposição</td>
          <td colspan="2">
            <textarea rows="2" style="resize:vertical" type="text" class="form-control" v-model="model.recomendation" placeholder="Recomendação da exposição" />
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import Events from '_utils/events';
import { cloneDeep } from '_utils';
import { mapActions } from 'vuex';
import { NOISE } from '_modules/settings/components/SettingsModel';
import { NOISE_CLASSIFICATION, _ADD_CONCLUSION_TAB_CLASSIFICATION_NOISE_, _LOAD_MODEL_, _ADD_ATTENUATED_DOSE_8_TAB_CLASSIFICATION_NOISE_ } from '../../SampleModel';

export default {
  name: 'Sample-Classification-Noise',
  props: {
    classification: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      model: cloneDeep(NOISE_CLASSIFICATION),
    };
  },
  computed: {
    noiseSettings() {
      const { noise } = this.$store.state.settings.results;
      if (noise) {
        return noise;
      }
      return { ...NOISE };
    },
  },
  methods: {
    ...mapActions([
      'getSettings',
      'activeAlert',
    ]),
    setModel() {
      if (this.classification) {
        if (this.classification.nho && this.classification.nr15) {
          this.model = cloneDeep(this.classification);
        } else {
          this.model = cloneDeep({ ...this.classification, nho: this.classification, nr15: this.classification });
        }
      }
    },
    getNormName(type) {
      const names = {
        nho: 'NHO 01',
        nr15: 'NR 15',
      };
      return names[type] || type.toUpperCase();
    },
    handleAddConclusion(data) {
      const {
        type, bgColor, dose, technicalConsiderations, recommendedAction,
      } = data;

      if (this.model[type]) {
        this.model[type].dose_daily = dose;
        this.model[type].consideration = technicalConsiderations;
        this.model[type].recommended_action = recommendedAction;
        this.model[type].bgColor = bgColor;
      }

      const message = `Conclusão da ${this.getNormName(type)} atualizada na aba Classificação`;

      this.activeAlert({
        message,
        theme: 'success',
      });
    },
    handleUpdateAttenuatedDose({ value, type }) {
      if (this.model[type]) {
        this.$set(this.model[type], 'attenuating_daily_dose', value);
      }

      this.activeAlert({
        message: `Dose Atenuante da ${this.getNormName(type)} atualizada na aba Classificação.`,
        theme: 'success',
      });
    },
  },
  mounted() {
    this.getSettings()
      .then(() => this.setModel());
    Events.$on(_LOAD_MODEL_, () => {
      this.setModel();
    });
    Events.$on(_ADD_CONCLUSION_TAB_CLASSIFICATION_NOISE_, this.handleAddConclusion);
    Events.$on(_ADD_ATTENUATED_DOSE_8_TAB_CLASSIFICATION_NOISE_, this.handleUpdateAttenuatedDose);
  },
  beforeDestroy() {
    Events.$off(_ADD_CONCLUSION_TAB_CLASSIFICATION_NOISE_, this.handleAddConclusion);
    Events.$off(_ADD_ATTENUATED_DOSE_8_TAB_CLASSIFICATION_NOISE_, this.handleUpdateAttenuatedDose);
  },
  watch: {
    model: {
      handler(value) {
        this.$emit('update:classification', value);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
td {
  vertical-align: middle;
}

input {
  min-width: 150px;
}
</style>
